<template>
  <div>
    <v-row row wrap no-gutters justify-start class="mx-5">
        <v-col cols="1" md="1" xs="1" sm="1"></v-col>
        <v-col cols="11" md="9" xs="9" sm="9" class="mt-n6" v-if="($vuetify.breakpoint.lg || $vuetify.breakpoint.md || $vuetify.breakpoint.xl)">
            <div style=" height: 50%; width: 50%; opacity: 0.9;">
                <v-col cols="12" md="12" xs="12" sm="12">
                    <div class="mt-12 pt-12" style="
                        font-style: normal;
                        font-weight: 700;
                        font-size: 38px;
                        line-height: 48px;
                        color: #0B3A8F;">
                        {{$t("loginpage.Register") }}
                    </div>
                    <span class="mt-12 pt-12" style="
                        font-style: normal;
                        font-weight: 400;
                        font-size: 18px;
                        color: #A1A1A1;
                        line-height: 22px;"
                    >
                        ONE Conference Anywhere Anytime
                    </span>
                </v-col>
                <v-stepper v-model="e1" alt-labels>
                    <v-stepper-header
                        style="font-size: 14px; box-shadow: 0px 0px 0px 0px;"
                    >
                        <v-stepper-step
                        :complete="e1 > 1"
                        color="#0B3A8F"
                        :editable="editStep"
                        step="1"
                        edit-icon="mdi-check"
                        >
                        <span>{{$t("loginpage.Register") }}</span>
                        </v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step
                        :complete="e1 > 2"
                        color="#0B3A8F"
                        :editable="editStep"
                        step="2"
                        >
                        <span edit-icon="mdi-check"
                            >{{$t("loginpage.additional") }}</span
                        >
                        </v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items>
                        <v-form ref="formStepper1">
                        <v-stepper-content step="1">
                            <v-row no-gutters>
                            <v-col cols="12" md="12" sm="12" xs="12">
                                <v-text-field
                                :oninput="onlyNumber"
                                dense
                                outlined
                                :placeholder="$t('loginpage.phone')"
                                persistent-placeholder
                                v-model="phonenumber"
                                @keypress="filterKey"
                                :maxlength="max"
                                :rules="[rules.countTen, rules.required]"
                                >
                                </v-text-field>
                            </v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="12" md="12" sm="12" xs="12">
                                <v-text-field
                                dense
                                outlined
                                :placeholder="$t('loginpage.username')"
                                persistent-placeholder
                                v-model="username"
                                @keypress="filterUsername"
                                :rules="[rules.required, rules.countSix]"
                                ></v-text-field>
                            </v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="12" md="12" sm="12" xs="12">
                                <v-text-field
                                dense
                                outlined
                                :placeholder="$t('loginpage.password')"
                                persistent-placeholder
                                v-model="password"
                                :rules="passwordRule"
                                :append-icon="
                                showPassword ? 'mdi-eye' : 'mdi-eye-off'
                                "
                                :type="showPassword ? 'text' : 'password'"
                                @click:append="showPassword = !showPassword"
                                persistent-hint
                                @keydown="filterSpacebar"
                                >
                                </v-text-field>
                            </v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="12" md="12" sm="12" xs="12">
                                <v-text-field
                                dense
                                outlined
                                :placeholder="$t('loginpage.confirmedPassword')"
                                persistent-placeholder
                                v-model="confirmedPassword"
                                :append-icon="
                                    showConfirmPass ? 'mdi-eye' : 'mdi-eye-off'
                                "
                                :rules="[rules.confirmPassword, rules.required]"
                                :type="showConfirmPass ? 'text' : 'password'"
                                @click:append="showConfirmPass = !showConfirmPass"
                                @keydown="filterSpacebar"
                                ></v-text-field>
                            </v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="12" md="12" sm="12" xs="12">
                                <v-btn
                                block
                                color="#3D85C6"
                                @click="e1 = 2"
                                :disabled="nextStepper1"
                                style="color: white;"
                                >
                                <span style="font-size: 18px;">{{$t("button.btnnext") }}</span>
                                </v-btn>
                            </v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            <v-col
                                cols="10"
                                md="10"
                                sm="10"
                                xs="10"
                                align="center"
                                class="pt-4"
                            >
                                <span style="font-size: 14px;">
                                  {{$t("loginpage.user") }}
                                </span>
                                <v-btn
                                @click="openModelSignin"
                                text
                                color="#3D85C6"
                                class="p-0 m-0 mt-n1"
                                >
                                {{$t("loginpage.login") }}
                                </v-btn>
                            </v-col>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            </v-row>
                        </v-stepper-content>
                    </v-form>

                        <v-form ref="formStepper2">
                        <v-stepper-content step="2">
                            <v-row no-gutters>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            <v-col cols="10" md="10" sm="10" xs="10">
                                <v-text-field
                                dense
                                outlined
                                :placeholder= "$t('loginpage.nameeng')"
                                persistent-placeholder
                                v-model="name"
                                :rules="[rules.onlyEng]"
                                @keypress="filterOnlyEngCharacter"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            <v-col cols="10" md="10" sm="10" xs="10">
                                <v-text-field
                                :rules="[rules.onlyEng]"
                                dense
                                outlined
                                :placeholder= "$t('loginpage.lastnameeng')"
                                persistent-placeholder
                                v-model="lastname"
                                @keypress="filterOnlyEngCharacter"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            <v-col cols="10" md="10" sm="10" xs="10">
                                <v-text-field
                                dense
                                outlined
                                :placeholder= "$t('loginpage.company')"
                                persistent-placeholder
                                v-model="company"
                                :rules="[rules.required]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            <v-col
                                cols="10"
                                md="10"
                                sm="10"
                                xs="10"
                                class="pb-5"
                                align-self="center"
                            >
                                <b-form-checkbox v-model="agreePrivacy">
                                  <span>
                                    {{$t("loginpage.Accept") }}
                                  </span>
                                  <span class="pointer" @click="PrivacyNotice()" style="color:#2083e4;cursor: pointer;">
                                    {{$t("loginpage.oneid") }}
                                  </span>
                                  <span>
                                    {{$t("loginpage.and") }}
                                  </span>
                                  <span class="pointer" @click="ProtectionPolicy()" style="color:#2083e4;cursor: pointer;">
                                    {{$t("loginpage.Privacy") }}
                                  </span>
                                  <!-- <span class="pointer" @click="openModalTermOfUser" style="font-size: 14px; color: #0B3A8F;">{{$t("loginpage.oneid") }}</span> -->
                                <!-- <span style="font-size: 14px;">
                                    ยอมรับ
                                </span>
                                <a @click="openModalTermOfUser">
                                    <span style="color: #0B3A8F;">
                                    ข้อกำหนดการใช้บริการ ONE ID
                                    </span>
                                </a>
                                <span style="font-size: 14px">
                                    และ
                                </span>
                                <a @click="openModalTermOfUser">
                                    <span style="color: #0B3A8F;"
                                    >นโยบาย ความคุ้มครองข้อมูลส่วนบุคคล</span
                                    >
                                </a> -->
                                </b-form-checkbox>
                            </v-col>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            <v-col cols="10" md="10" sm="10" xs="10">
                                <v-btn
                                :disabled="nextStepper2"
                                block
                                color="#3D85C6"
                                :loading="loading"
                                @click="register"
                                style="color: white;"
                                >
                                <span style="font-size: 18px;">{{$t("loginpage.Register") }}</span>
                                </v-btn>
                            </v-col>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            </v-row>
                           
                            <v-row no-gutters>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            <v-col
                                cols="10"
                                md="10"
                                sm="10"
                                xs="10"
                                align="center"
                                class="pt-4"
                            >
                                <span style="font-size: 14px;">
                                  {{$t("loginpage.user") }}
                                </span>
                                <v-btn
                                text
                                color="#3D85C6"
                                class="p-0 m-0 mt-n1"
                                @click="openModelSignin"
                                >
                                {{$t("loginpage.login") }}
                                </v-btn>
                            </v-col>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            </v-row>
                            <v-row no-gutters>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            <v-col
                                cols="10"
                                md="10"
                                sm="10"
                                xs="10"
                                class="pt-4"
                            >
                                <v-btn
                                text
                                color="primary"
                                class="p-0 m-0 mt-n1"
                                @click="e1 = 1"
                                >
                                {{$t("button.btnback") }}
                                </v-btn>
                            </v-col>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            </v-row>
                        </v-stepper-content>
                        </v-form>
                    </v-stepper-items>
                </v-stepper>
            </div>
        </v-col>
        <v-col cols="12" md="12" xs="12" sm="12" class="mt-n6" v-if="($vuetify.breakpoint.sm || $vuetify.breakpoint.xs)">
            <div class="pa-4 text-center rounded-t-xl" style="background-color: #F5F5F5; height: 100%; width: 100%; opacity: 0.9;">
                <v-col cols="12" md="12" xs="12" sm="12">
                    <div class="mt-12 pt-12" style="font-family: Ebrima;
                        font-style: normal;
                        font-weight: 700;
                        font-size: 38px;
                        line-height: 48px;
                        color: #0B3A8F;">
                        {{$t("loginpage.Register") }}
                    </div>
                    <span class="mt-12 pt-12" style="font-family: Ebrima;
                        font-style: normal;
                        font-weight: 400;
                        font-size: 18px;
                        color: #A1A1A1;
                        line-height: 22px;"
                    >
                        ONE Conference Anywhere Anytime
                    </span>
                </v-col>
                <v-stepper v-model="e1" alt-labels class="bgTransparent">
                    <v-stepper-header
                        style="font-size: 14px; box-shadow: 0px 0px 0px 0px;"
                    >
                        <v-stepper-step
                        :complete="e1 > 1"
                        color="#0B3A8F"
                        :editable="editStep"
                        step="1"
                        edit-icon="mdi-check"
                        >
                        <span>{{$t("loginpage.Register") }}</span>
                        </v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step
                        :complete="e1 > 2"
                        color="#0B3A8F"
                        :editable="editStep"
                        step="2"
                        >
                        <span edit-icon="mdi-check"
                            >{{$t("loginpage.additional") }}</span
                        >
                        </v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items>
                        <v-form ref="formStepper1">
                        <v-stepper-content step="1">
                            <v-row no-gutters>
                            <v-col cols="12" md="12" sm="12" xs="12">
                                <v-text-field
                                :oninput="onlyNumber"
                                dense
                                outlined
                                :placeholder="$t('loginpage.phone')"
                                persistent-placeholder
                                v-model="phonenumber"
                                @keypress="filterKey"
                                :maxlength="max"
                                :rules="[rules.countTen, rules.required]"
                                >
                                </v-text-field>
                            </v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="12" md="12" sm="12" xs="12">
                                <v-text-field
                                :oninput="onlyuser"
                                dense
                                outlined
                                :placeholder="$t('loginpage.username')"
                                persistent-placeholder
                                v-model="username"
                                @keypress="filterUsername"
                                :rules="[rules.required, rules.countSix]"
                                ></v-text-field>
                            </v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="12" md="12" sm="12" xs="12">
                                <v-text-field
                                :oninput="onlypass"
                                dense
                                outlined
                                :placeholder="$t('loginpage.password')"
                                persistent-placeholder
                                v-model="password"
                                :rules="passwordRule"
                                :append-icon="
                                showPassword ? 'mdi-eye' : 'mdi-eye-off'
                                "
                                :type="showPassword ? 'text' : 'password'"
                                @click:append="showPassword = !showPassword"
                                persistent-hint
                                @keydown="filterSpacebar"
                                >
                                </v-text-field>
                            </v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="12" md="12" sm="12" xs="12">
                                <v-text-field
                                :oninput="onlypass"
                                dense
                                outlined
                                :placeholder="$t('loginpage.confirmedPassword')"  
                                persistent-placeholder
                                v-model="confirmedPassword"
                                :append-icon="
                                    showConfirmPass ? 'mdi-eye' : 'mdi-eye-off'
                                "
                                :rules="[rules.confirmPassword, rules.required]"
                                :type="showConfirmPass ? 'text' : 'password'"
                                @click:append="showConfirmPass = !showConfirmPass"
                                @keydown="filterSpacebar"
                                ></v-text-field>
                            </v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="12" md="12" sm="12" xs="12">
                                <v-btn
                                block
                                color="#3D85C6"
                                @click="e1 = 2"
                                :disabled="nextStepper1"
                                style="color: white;"
                                >
                                <span style="font-size: 18px;">{{$t("button.btnnext") }}</span>
                                </v-btn>
                            </v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            <v-col
                                cols="10"
                                md="10"
                                sm="10"
                                xs="10"
                                align="center"
                                class="pt-4"
                            >
                                <span style="font-size: 14px;">
                                  {{$t("loginpage.user") }}
                                </span>
                                <v-btn
                                @click="openModelSignin"
                                text
                                color="#3D85C6"
                                class="p-0 m-0 mt-n1"
                                >
                                {{$t("loginpage.login") }}
                                </v-btn>
                            </v-col>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            </v-row>
                        </v-stepper-content>
                    </v-form>

                        <v-form ref="formStepper2">
                        <v-stepper-content step="2">
                            <v-row no-gutters>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            <v-col cols="10" md="10" sm="10" xs="10">
                                <v-text-field
                                :oninput="onlynameeng"
                                dense
                                outlined
                                :placeholder= "$t('loginpage.nameeng')"
                                persistent-placeholder
                                v-model="name"
                                :rules="[rules.onlyEng]"
                                @keypress="filterOnlyEngCharacter"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            <v-col cols="10" md="10" sm="10" xs="10">
                                <v-text-field
                                :oninput="onlynameeng"
                                :rules="[rules.onlyEng]"
                                dense
                                outlined
                                :placeholder= "$t('loginpage.lastnameeng')"
                                persistent-placeholder
                                v-model="lastname"
                                @keypress="filterOnlyEngCharacter"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            <v-col cols="10" md="10" sm="10" xs="10">
                                <v-text-field
                                dense
                                outlined
                                :placeholder= "$t('loginpage.company')"
                                persistent-placeholder
                                v-model="company"
                                :rules="[rules.required]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            <v-col
                                cols="10"
                                md="10"
                                sm="10"
                                xs="10"
                                class="pb-5"
                                align-self="center"
                            >
                                <b-form-checkbox v-model="agreePrivacy">
                                  <span>
                                    {{$t("loginpage.Accept") }}
                                  </span>
                                  <span class="pointer" @click="PrivacyNotice()" style="color:#2083e4;cursor: pointer;">
                                    {{$t("loginpage.oneid") }}
                                  </span>
                                  <span>
                                    {{$t("loginpage.and") }}
                                  </span>
                                  <span class="pointer" @click="ProtectionPolicy()" style="color:#2083e4;cursor: pointer;">
                                    {{$t("loginpage.Privacy") }}
                                  </span>
                                  <!-- <span class="pointer" @click="openModalTermOfUser" style="font-size: 20px;">{{$t("loginpage.oneid") }}</span> -->
                                <!-- <span style="font-size: 14px;">
                                    ยอมรับ
                                </span>
                                <a @click="openModalTermOfUser">
                                    <span style="color: #0B3A8F;">
                                    ข้อกำหนดการใช้บริการ ONE ID
                                    </span>
                                </a>
                                <span style="font-size: 14px">
                                    และ
                                </span>
                                <a @click="openModalTermOfUser">
                                    <span style="color: #0B3A8F;"
                                    >นโยบาย ความคุ้มครองข้อมูลส่วนบุคคล</span
                                    >
                                </a> -->
                                </b-form-checkbox>
                            </v-col>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            <v-col cols="10" md="10" sm="10" xs="10">
                                <v-btn
                                :disabled="nextStepper2"
                                block
                                color="#3D85C6"
                                :loading="loading"
                                @click="register"
                                style="color: white;"
                                >
                                <span style="font-size: 18px;">{{$t("loginpage.Register") }}</span>
                                </v-btn>
                            </v-col>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            </v-row>

                            <v-row no-gutters>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            <v-col
                                cols="10"
                                md="10"
                                sm="10"
                                xs="10"
                                align="center"
                                class="pt-4"
                            >
                                <span style="font-size: 14px;">
                                  {{$t("loginpage.user") }}
                                </span>
                                <v-btn
                                text
                                color="#3D85C6"
                                class="p-0 m-0 mt-n1"
                                @click="openModelSignin"
                                >
                                {{$t("loginpage.login") }}
                                </v-btn>
                            </v-col>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            </v-row>
                            <v-row no-gutters>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            <v-col
                                cols="10"
                                md="10"
                                sm="10"
                                xs="10"
                                class="pt-4"
                            >
                                <v-btn
                                text
                                color="primary"
                                class="p-0 m-0 mt-n1"
                                @click="e1 = 1"
                                >
                                {{$t("button.btnback") }}
                                </v-btn>
                            </v-col>
                            <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                            </v-row>
                        </v-stepper-content>
                        </v-form>
                    </v-stepper-items>
                </v-stepper>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" sm="12" xs="12">
            <!-- <Footer /> -->
          </v-col>
        </v-row>
      </div>
  </template>

<script>
import { mapState, mapActions } from 'vuex'
import CryptoJS from "crypto-js";
import Footer from "../Footer.vue";
import { mask } from 'vue-the-mask'
export default {
  directives: {
    mask
  },
  components: {
    // Footer
  },
  data() {
    return {
      mask: 'XXXX',
      onlynameeng: "this.value = this.value.replace(/[^a-zA-Z]|/g, '')",
      onlyNumber: "this.value = this.value.replace(/[^0-9]|/g, '').substr(0,10)",
      onlyuser: "this.value = this.value.replace(/[^0-9a-zA-Z!().,`|_;:@#$%&*~+-/?]|/g, '')",
      onlypass: "this.value = this.value.replace(/[^0-9a-zA-Z!(){}''.|=`<>,^_;:@#$%&*~+-/?]|/g, '')",
      tab: null,
      e1: 1,
      username: '',
      password: '',
      confirmedPassword: '',
      name: '',
      lastname: '',
      phonenumber: '',
      company: '',
      usertoken: '',
      agreePrivacy: false,
      showPassword: false,
      jwt: require('jsonwebtoken'),
      showConfirmPass: false,
      nextStepper1: true,
      nextStepper2: true,
      max: 10,
      editStep: false,
      loading: false,
      rules: {
        required: value => !!value || this.$t("loginpage.Pleasespecify"),
        confirmPassword: value => {
          return value === this.password || this.$t("loginpage.passdonot")
        },
        countTen: value => {
          return value.length === 10 || this.$t("loginpage.countTen")
        },
        onlyEng: value => !!value || this.$t("loginpage.onlyeng"),
        countSix: value => {
          return value.length >= 6 || this.$t("loginpage.countSix")
        }
      },
      passwordRule: [
        v => !!v || this.$t("loginpage.Pleasespecify"),
        v => /(?=.*[a-z])/.test(v) || this.$t("loginpage.Letters"),
        v => /(?=.*[A-Z])/.test(v) || this.$t("loginpage.Letters"),
        v => /(?=.*\d)/.test(v) || this.$t("loginpage.Letters"),
        v => /([!@#$%^&*()_+|~-])/.test(v) || this.$t("loginpage.Letters"),
        v => (v && v.length >= 8) || this.$t("loginpage.Letters")
      ]
    }
  },
  created() {
    this.$multiwatch(
      ['phonenumber', 'username', 'password', 'confirmedPassword'],
      function() {
        const valid = this.$refs.formStepper1.validate()
        this.nextStepper1 = !valid
      }
    )
    this.$multiwatch(['name', 'lastname', 'company'], function() {
      const valid = this.$refs.formStepper2.validate()
      if (this.agreePrivacy === true) {
        this.nextStepper2 = !valid
        // console.log(this.nextStepper2)
      }
    })
  },
  computed: {
    ...mapState('dialog', ['roleUser', 'switchSigninSignup'])
  },
  watch: {
    agreePrivacy(value) {
      if (value) {
        this.checkDisabledBtn()
      } else {
        this.nextStepper2 = true
      }
    }
  },
  methods: {
    ...mapActions('dialog', [
      'setSwitchSignSignup',
      'setDialogTermOfUserOneChat',
      'setUsername',
      'setUserRole'
    ]),
    filterUsername(e) {
      // only english and number
      const key = e.which ? e.which : e.keyCode
      if (key >= 48 && key <= 57) {
        return true
      } // number
      if (key >= 65 && key <= 90) {
        return true
      } // A-Z
      if (key >= 97 && key <= 122) {
        return true
      } // a-z
      return e.preventDefault()
    },
    filterOnlyEngCharacter(e) {
      var key = e.which ? e.which : e.keyCode
      // a-z
      if (key >= 65 && key <= 90) {
        return true
      }
      // A-Z
      if (key >= 97 && key <= 122) {
        return true
      }
      return e.preventDefault()
    },
    filterKey(e) {
      const key = e.which ? e.which : e.keyCode
      if (key > 31 && (key < 48 || key > 57)) {
        return e.preventDefault()
      }
    },
    filterSpacebar(e) {
      const key = e.which ? e.which : e.keyCode
      if (key === 32) {
        return e.preventDefault()
      }
    },
    PrivacyNotice() {
      window.open(
        process.env.VUE_APP_POLICIES + '?' + 'tabs=' + 0,
        "_blank"
      );
    },
    ProtectionPolicy() {
      window.open(
        process.env.VUE_APP_POLICIES + '?' + 'tabs=' + 1,
        "_blank"
      );
    },
    encodeJS(data) {
      // console.log(data)
    try {
      var ciphertext = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        process.env.VUE_APP_SECRET_KEY
      ).toString();
      this.usertoken = ciphertext
      return ciphertext;
    } catch (error) {
      console.log(error);
      return error;
    }
    },
    register() {
      this.loading = true
      this.nextStepper2 = true
      if (this.agreePrivacy === true) {
        var data = {
          username: this.username,
          password: this.password,
          // passwordconfirm: this.confirmedPassword,
          company: this.company,
          first_name_eng: this.name,
          last_name_eng: this.lastname,
          mobile_no: this.phonenumber
        }
        this.axios
          .post(process.env.VUE_APP_API + '/api/v1/regis/register', data)
          .then(response => {
            // console.log('response.data', response.data.message)
            if (response.data.result === 'Success') {
              // console.log('response.data', response.data.data)
              this.$swal('success', response.data.message, 'success')
              // this.openModelSignin()
              this.loginoneid()
            } else {
              this.loading = false
              this.editStep = true
              this.nextStepper2 = false
              this.$swal('WARNING !', response.data.message, 'warning')
            }
          })
          .catch(e => {
            console.log(e.message)
            this.editStep = true
            this.loading = false
            this.nextStepper2 = false
            this.$swal('WARNING !', this.$t("loginpage.duplicate"), 'warning')
            // if (e.status === 400) {
            //   this.editStep = true
            //   this.loading = false
            //   this.nextStepper2 = false
            //   this.$swal('WARNING !', 'Please, check your input', 'warning')
            // } else {
            //   this.editStep = true
            //   this.loading = false
            //   this.nextStepper2 = false
            //   this.$swal('WARNING !', e.data.message, 'warning')
            // }
          })
      } else if (this.agreePrivacy === false) {
        this.loading = false
        this.nextStepper2 = false
        this.$swal(
          '',
          this.$t("loginpage.oneid"),
          'warning'
        )
      }
    },
    decodejwttoken(data) {
      var token = data
      const decryptedText = this.CryptoJS.AES.decrypt(
        token,
        process.env.VUE_APP_SECRET_KEY
      )
        .toString(this.CryptoJS.enc.Utf8)
        .replace(/"/g, '')
      var data = this.jwt.decode(decryptedText)
      // var userData = data
      // console.log('this.userData', data.user._id)
      this.createthem(data.user._id)
    },
    createthem(userid) {
      this.goPage("/manage");
      // this.axios
      //     .post(process.env.VUE_APP_API + "/api/v1/theme/create/", {
      //       user_id: userid
      // }).then(res => {
      //   if( res.data.result === 'Created' || res.data.result === 'Success'){
      //     this.goPage('/manage')
      //   }
      // }).catch(err => {
      //   console.log('createidprofile', err.message)
      // })
    },
    loginoneid() {
      this.encodeJS(JSON.stringify({ username: this.username, password: this.password}))
      this.axios.post(process.env.VUE_APP_API + '/api/lv1/auth/login', {
        token : this.usertoken
        // username: this.username,
        // password: this.password
      }).then(res => {
        if (res.data.code === 200) {
          // console.log('200', res.data)
          if (res.data.result === 'Success') {
            this.loadingApiLogin = false
            this.Disabled = false
            localStorage.setItem('user-token', res.data.data.token)
            localStorage.setItem("oneid-token", res.data.data.oneid);
            // localStorage.setItem('access-token', res.data.data.oneid.access_token)
            // localStorage.setItem( "refresh_token",  res.data.data.oneid.refresh_token );
            // this.checkrole()
            this.decodejwttoken(res.data.data.token)
            // console.log('Success', res.data)
            this.$swal(res.data.message, '', 'success')
          } else {
            this.loadingApiLogin = false
            this.Disabled = false
            this.$swal(res.data.message, '', 'warning')
            // console.log('warning', res.data)
          }
        } else {
          this.$swal(res.data.message, '', 'warning')
          this.loadingApiLogin = false
          this.Disabled = false
        }
      }).catch(e => {
        console.log('400', e)
        this.loadingApiLogin = false
        this.Disabled = false
      })
    //   console.log('env', process.env.VUE_APP_API)
    //   console.log('username', this.username)
    //   console.log('password', this.password)
    },
    // async checkrole() {
    //   try {
    //     var { data } = await this.axios.post(
    //       process.env.VUE_APP_API + '/api/v1/role/checkrole/'
    //     )
    //     var roles = data.data.role.name
    //     const encryptedRole = this.CryptoJS.AES.encrypt(
    //       roles,
    //       'One Conference'
    //     ).toString()
    //     // console.log('encryptedRole', encryptedRole)
    //     localStorage.setItem('role', encryptedRole)
    //     this.goPage('/activate')
    //   // const redirect = this.$route.query.redirect
    //   } catch (err) {
    //     console.log(err)
    //   }
    // },
    openModelSignin() {
      // console.log('get')
      this.setSwitchSignSignup(false)
    //   window.location.reload()
    },
    openModalTermOfUser() {
      window.open(process.env.VUE_APP_ONEID + '/api/term-of-use', '_blank')
      // this.setDialogTermOfUserOneChat(true)
    },
    goPage(link) {
      // console.log('gotolink', link)
      this.$router.push(link).catch(e => {
        // console.log(e.message)
      })
    },
    // async checkRoleUser() {
    //   try {
    //     var { data } = await this.axios.post(
    //       process.env.VUE_APP_API + '/api/users/checkroleuser'
    //     )
    //     // console.log('data role', data.role.name)
    //     var roles = data.role.name
    //     const encryptedRole = this.CryptoJS.AES.encrypt(
    //       roles,
    //       'One Conference'
    //     ).toString()
    //     // console.log('encryptRole', encryptedRole)
    //     localStorage.setItem('role', encryptedRole)
    //     if (localStorage.getItem('uuidJoin') !== null) {
    //       var uuidJoin = localStorage.getItem('uuidJoin')
    //       localStorage.removeItem('uuidJoin')
    //       // this.$cookies.remove('uuidJoin')
    //       window.location.href =
    //         process.env.VUE_APP_DOMAIN + '/join?uuid=' + uuidJoin
    //     } else if (roles === 'user') {
    //       this.setUserRole('user')
    //       this.goPage('/joinuserrole')
    //     } else if (roles === 'citizen') {
    //       this.setUserRole('citizen')
    //       // this.goPage('/citizenrole')
    //       this.goPage('/main')
    //       // this.$swal('WARNING!', roles, 'infomation')
    //     } else {
    //       // console.log('role admin')
    //       this.setUserRole('host')
    //       this.goPage('/main')
    //     }
    //   } catch (error) {
    //     console.log(error)
    //   }
    // },
    // async chklogins() {
    //   await this.axios.post(
    //     process.env.VUE_APP_API + '/api/auth/loginoneid',
    //     {
    //       username: this.username,
    //       password: this.password
    //     }
    //   ).then(res => {
    //     if (res.status === 200) {
    //       localStorage.setItem('user-token', res.data.token)
    //       // this.checkRoleUser()
    //     }
    //   }).catch(e => {
    //     console.log('loginoneid: ', e.response)
    //   })
    // },
    checkDisabledBtn () {
      const valid = this.$refs.formStepper2.validate()
      if (valid === true) {
        this.nextStepper2 = false
      } else {
        this.nextStepper2 = true
      }
    }
  }
}
</script>
<style scoped>
.bgTransparent {
  background-color: transparent !important;
}
.v-messages__message {
  color: red;
}
</style>
